<template>
    <ValidationProvider
        v-slot="{ errors }"
        :name="label"
        :vid="name"
        :rules="rules"
    >
        <PasswordField
            v-model="innerValue"
            :errors="errors"
            v-bind="{...$attrs, ...$props}"
        />
    </ValidationProvider>
</template>

<script>
import ValidationProvider from '@/validator';
import PasswordField from '../PasswordField.vue';
import fieldMixin from '@/mixins/fieldMixin';
export default {
    components: {
        ValidationProvider,
        PasswordField,
    },
    mixins: [fieldMixin],
    props: {
        rules: {
            type: String,
            default: '',
        },
    },
};
</script>

<style></style>
